import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Click a gallery thumbnail to open it full-size in a Bootstrap modal.
// Reads the larger src from the clicked thumbnail's `data-lightbox-src`.
export default class extends Controller {
  static targets = ["image", "modal"]

  open(event) {
    event.preventDefault()
    const src = event.currentTarget.dataset.lightboxSrc
    if (!src) return
    this.imageTarget.src = src
    Modal.getOrCreateInstance(this.modalTarget).show()
  }
}
